import $axiosProtected from "../../common/utils/axiosUtils";

// Get Patient Health Conditions based on UHID
export const getPatientHealthConditions = async (payload: any) => {
  return await $axiosProtected().post(
    `/patient/condition-details/uhid/all/get`,
    payload
  );
};
